import Axios from 'axios';
import { createContext, ReactNode, useEffect, useState } from 'react';
import { Enterprise } from '../model';
import { getBffUrl } from '../utils/EnvironmentUtils';

export interface ICurrentEnterpriseValues {
    enterprise: Enterprise | null;
    fetchEnterprise: () => void;
}

interface CurrentEnterpriseContextProviderProps {
    children: ReactNode;
    initialValue?: Enterprise;
}

export const CurrentEnterpriseContext = createContext<ICurrentEnterpriseValues | null>(null);

export function CurrentEnterpriseContextProvider(props: CurrentEnterpriseContextProviderProps) {
    const [enterprise, setEnterprise] = useState<Enterprise | null>(props.initialValue || null);

    const axios = Axios.create({
        baseURL: getBffUrl(window.location.host),
    });

    const fetchEnterprise = () => {
        axios({
            url: `GetEnterprise`,
            method: 'get',
            headers: {
                'x-csrf': '1',
            },
            withCredentials: true,
        }).then((response) => {
            if (response.data) setEnterprise(response.data);
        });
    };

    useEffect(() => {
        fetchEnterprise();
    }, []);

    return (
        <CurrentEnterpriseContext.Provider value={{ enterprise, fetchEnterprise }}>
            {enterprise ? props.children : undefined}
        </CurrentEnterpriseContext.Provider>
    );
}
